import {Directive, HostBinding, HostListener, output} from '@angular/core'

@Directive({
  selector: '[appDragAndDrop]',
})
export class DragAndDropDirective {
  @HostBinding('class.file-over') fileOver: boolean

  readonly fileDropped = output<any>()

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.fileOver = true
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) onDragLeave(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.fileOver = false
  }

  // Drop listener
  @HostListener('drop', ['$event']) ondrop(evt) {
    evt.preventDefault()
    evt.stopPropagation()
    this.fileOver = false
    const files = evt.dataTransfer.files
    if (files.length > 0) {
      this.fileDropped.emit(files)
    }
  }
}
